export const ERR_REDIRECT = {
    message: "We're redirecting you to sign in to your account.",
};
export const ERR_UNABLE_TO_SAVE = {
    message: "We couldn't save your changes. Refresh the page and try again.",
};
export const ERR_GENERIC = {
    message: 'Something went wrong. Refresh the page and try again.',
};
export const ERR_GENERIC_MODAL = {
    message: 'Something went wrong. Please close this window and try again.',
};
export const ERR_ZIPCODE_FIND = {
    message: "We can't find this ZIP code. Refresh the page and try again.",
};
export const ERR_NO_SAVED_ADR = {
    message: "You currently don't have any saved addresses.",
};
export const ERR_UNABLE_TO_SAVE_PAYMENT = {
    message: "We couldn't save your changes. Refresh the page and try again.",
};
export const ERR_INVALID_PAYMENT = {
    message: "We weren't able to save your changes. Review the card details and try again.",
};
export const ERR_PAYMENT_ALREADY_ADDED = {
    message: 'This card has already been added to your account.',
};
export const DELETED_CITI_CARDS_ERROR_MSG1 = {
    message: 'We were unable to delete credit cards associated with Citi Account ID ****',
};
export const DELETED_CITI_CARDS_ERROR_MSG2 = {
    message: '. Please try again later.',
};
export const UNABLE_TO_COMPLETE_ERROR = {
    message: "We're unable to complete this action. Refresh the page and try again.",
};
export const ERR_UNABLE_TO_RESEND_INVITE = {
    message: "We're unable to resend this Text2Confirm invite. Please try again.",
};
export const ERR_UNABLE_TO_AUTH_PROX_CARD_ON_HD_PASS = {
    message: 'We cannot authorize this type of card for HD Pass. Please try entering a different card.',
};
export const ERR_RECAPTCHA = {
    message: 'Something went wrong. Click the Cancel button below and try again.',
};
export const REMOTE_PURCHASE_INVALID_INFO = {
    message: "We weren't able to authorize your card. Review the card details and try again.",
};
export const HD_PASS_INVALID_INFO = {
    message: "We weren't able to authorize your card. Review the card details and try again.",
};
export const INVALID_CARD_TYPE = {
    message: 'This card type is not valid to be added to an account. Please enter a different card number and try again.',
};
export const ERR_MAX_T2C_TENDER_LIMIT = {
    message: "You've reached the maximum of Text2Confirm payment methods. To authorize for Text2Confirm, you must first unenroll a previous method.",
};
export const ERR_BULK_ADD_NOT_AVAILABLE = {
    message: 'Bulk adding credit cards is not available on this account.',
};
export const ERR_IC_NOT_AVAILABLE_FOR_PRO_ACCOUNTS = {
    message: 'Instant Checkout is unavailable on Pro accounts.',
};
export const ERR_FISERV_FAIL = {
    message: 'Please re-enter your information',
};
